import React, { Component }  from 'react';
import axios from "axios";
import Layout from "./Components/Layout";
import PaginatedItems from "./Components/Pagination";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import CsvBoxxComponent from "./Components/CsvBoxxComponent";

const badgeStyles = `
.table-container {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
    overflow-x: hidden;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f8f9fa !important;
}
.table-container table {
    table-layout: fixed;
    width: 100%;
}
.table-container td {
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}
`;

export class Purchases extends Component {
    state = {
        brands: [],
        products:[],
        selectBrand: {},
        fromDate : new Date(),
        toDate : new Date(),
        purchases:[],
        sources:[],
        vendor: "",
        skuType: "",
        search: "",
        totalAmount:0,
        totalQty:0,
        orderBY: 6,
        pageNumber:1,
        orderDesc:true,
        totalItems: 0,
        isPrint:false,
        printText: "Print",
        showClearFilters : false,
        showFile:false,
        showDatePopover: false,
        perPage: parseInt(localStorage.getItem('purchasesPerPage')) || 25
    }

    getProducts(fromDate, toDate, vendor, skuType, search, pageNumber, orderBY, orderDesc) {
        let dataObj = {
            start_datetime:  fromDate,
            end_datetime: toDate,
            vendor: vendor,
            skuType: skuType,
            search: search,
            page:pageNumber,
            order:orderBY,
            orderDesc: orderDesc === true ? 1 : 0,
            per_page: this.state.perPage
        }
        if(fromDate !== "" && toDate !== "") {
            axios.put(`purchases/get-purchases`, dataObj)
                .then(response => {
                    const purchases = JSON.parse(response.data.results)
                    this.setState({ purchases })

                    const totalAmount = response.data.total_amount
                    this.setState({ totalAmount });

                    const totalQty = response.data.total_qty
                    this.setState({ totalQty });
                    
                    const totalItems = response.data.total_records
                    this.setState({ totalItems });

                    const sources = response.data.sources
                    this.setState({ sources });
                }).catch(error => {
                console.error('There was an error!', error);
            });
        }
    }
    
    paginatePage = (page)=> {
        this.setState({ pageNumber : page });
        this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, page, this.state.orderBY, this.state.orderDesc)
    }

    formatDateRange = () => {
        const fromDate = this.state.fromDate;
        const toDate = this.state.toDate;
        
        if (!fromDate || !toDate) return 'Select Date Range';
        
        const formatDate = (date) => {
            return date.toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric',
                year: 'numeric'
            });
        };
        
        return `${formatDate(fromDate)} - ${formatDate(toDate)}`;
    }
    
    customParseFloat(amount) {
        if (!amount) {
            amount = "0";
        }
        return parseFloat(amount);
    }

    setFromDate(e) {
        const fromDate = new Date(e);
        this.setState({ fromDate });
        this.getProducts(fromDate, this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    setToDate(e) {
        const toDate = new Date(e);
        this.setState({ toDate });
        this.getProducts(this.state.fromDate, toDate, this.state.vendor, this.state.skuType, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }
    
    onOrderBy(e, order) {
        let orderDesc = true;
        if(parseInt(order) === this.state.orderBY) {
            orderDesc = !this.state.orderDesc;
        } else {
            orderDesc = true;
        }
        this.setState({ orderBY: parseInt(order), orderDesc: orderDesc });
        this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, this.state.pageNumber, parseInt(order), orderDesc)
    }

    selectSourceName(e) {
        const showClearFilters = true;
        this.setState({ showClearFilters })
        this.setState({ vendor: e.target.value })
        this.getProducts(this.state.fromDate, this.state.toDate, e.target.value, this.state.skuType, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    onSearch(e) {
        this.setState({ search: e.target.value })
    }

    numberWithCommas(x) {
        if(x === undefined || x === null || x === "") {
            return "$0.00";
        }
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "$" + parts.join(".");
    }

    numberWithCommasNotDollar(x) {
        if(x === undefined || x === null || x === "") {
            return "0";
        }
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    appendDollarSign(x) {
        if(x === undefined || x === null || x === "") {
            return "$0.00";
        }
        return "$" + x;
    }

    onClearFilters(e) {
        this.setState({ 
            vendor: "",
            skuType: "",
            search: "",
            showClearFilters: false 
        });
        this.getProducts(this.state.fromDate, this.state.toDate, "", "", "", this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    onExport(e) {
        let dataObj = {
            start_datetime:  this.state.fromDate,
            end_datetime: this.state.toDate,
            vendor: this.state.vendor,
            skuType: this.state.skuType,
            search: this.state.search,
            order:this.state.orderBY,
            orderDesc: this.state.orderDesc === true ? 1 : 0,
        }
        if(this.state.fromDate !== "" && this.state.toDate !== "") {
            axios.put(`purchases/download-purchases`, dataObj)
                .then(response => {
                    const element = document.createElement("a");
                    element.href = axios.defaults.baseURL + 'purchases/download-purchases/0';
                    element.download = "download.xlsx";
                    document.body.appendChild(element);
                    element.click();
                }).catch(error => {
                console.error('There was an error!', error);
            });
        }
    }

    handleComm(e, peakNumber) {
        const showClearFilters = true;
        this.setState({ showClearFilters })
        this.setState({ search: peakNumber })
        this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, this.state.skuType, peakNumber, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    };

    onSearchClick(e) {
        const showClearFilters = true;
        this.setState({ showClearFilters })
        this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    selectSkuType(e) {
        const showClearFilters = true;
        this.setState({ showClearFilters })
        this.setState({ skuType: e.target.value })
        this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, e.target.value, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    onKeyUp (e) {
        if (e.charCode === 13) {
            this.onSearchClick(e);
        }
    };

    onPerPageChange(e) {
        const perPage = parseInt(e.target.value);
        localStorage.setItem('purchasesPerPage', perPage);
        this.setState({ perPage, pageNumber: 1 }, () => {
            this.getProducts(this.state.fromDate, this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, 1, this.state.orderBY, this.state.orderDesc);
        });
    }

    componentDidMount() {
        const fromDate = new Date("January 01, 2023 01:00:01")
        this.setState({ fromDate })
        
        this.getProducts(fromDate.toISOString(), this.state.toDate, this.state.vendor, this.state.skuType, this.state.search, this.state.pageNumber, this.state.orderBY, this.state.orderDesc)
    }

    render() {
        return (
            <Layout>
                <style>
                    {`
                        ${badgeStyles}
                        .date-picker-popper .react-datepicker {
                            z-index: 99999 !important;
                        }
                        .react-datepicker-popper {
                            z-index: 99999 !important;
                        }
                        button[data-csvbox-initator="true"] {
                            background-color: transparent !important;
                            border: 1px solid #6c757d !important;
                            color: #6c757d !important;
                            padding: 8px 16px !important;
                            border-radius: 0.25rem !important;
                            font-size: 0.875rem !important;
                            gap: 8px !important;
                            display: flex !important;
                            align-items: center !important;
                            height: 38px !important;
                        }
                        button[data-csvbox-initator="true"]:hover {
                            background-color: #6c757d !important;
                            color: white !important;
                        }
                    `}
                </style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'hidden', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px' }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px' }}>
                            
                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Track and analyze all purchase transactions and expenses</p>
                                <div className="d-flex" style={{ gap: '10px' }}>
                                    <div style={{height: '38px', width: '100px'}}>
                                        <CsvBoxxComponent />
                                    </div>
                                    <button onClick={(e) => this.onExport(e)} className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                                            style={{ gap: '8px', padding: '8px 16px' }}>
                                        <i className="ti-export"></i>
                                        Export
                                    </button>
                                    {this.state.showClearFilters &&
                                        <button onClick={(e) => this.onClearFilters(e)} className="btn btn-outline-danger btn-sm d-flex align-items-center"
                                                style={{ gap: '8px', padding: '8px 16px' }}>
                                            <i className="ti-na"></i>
                                            Clear Filters
                                        </button>
                                    }
                                </div>
                            </div>

                            <div className="row" style={{'@media print': {display: 'none'}}}>
                                <div className="col-lg-12 mb-3">
                                    <div className="d-flex" style={{ gap: '10px', alignItems: 'start', justifyContent: 'space-between' }}>
                                        <div style={{ position: 'relative', flex: '1' }}>
                                            <button 
                                                className="btn btn-outline-secondary w-100" 
                                                style={{height: '38px', textAlign: 'left', fontSize: '12px'}}
                                                onClick={() => this.setState({showDatePopover: !this.state.showDatePopover})}
                                            >
                                                <i className="ti-calendar" style={{marginRight: '5px'}}></i>
                                                {this.formatDateRange()}
                                            </button>
                                            {this.state.showDatePopover && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '0',
                                                    backgroundColor: 'white',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    padding: '15px',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                                    zIndex: 9999,
                                                    width: '300px'
                                                }}>
                                                    <div style={{marginBottom: '10px'}}>
                                                        <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>From Date:</label>
                                                        <DatePicker 
                                                            selected={this.state.fromDate} 
                                                            onChange={(e) => this.setFromDate(e)}
                                                            className="form-control"
                                                            popperProps={{
                                                                strategy: "fixed",
                                                                modifiers: [
                                                                    {
                                                                        name: "preventOverflow",
                                                                        options: {
                                                                            altAxis: true,
                                                                            altBoundary: true,
                                                                        }
                                                                    }
                                                                ]
                                                            }}
                                                            popperClassName="date-picker-popper"
                                                        />
                                                    </div>
                                                    <div style={{marginBottom: '15px'}}>
                                                        <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>To Date:</label>
                                                        <DatePicker 
                                                            selected={this.state.toDate} 
                                                            onChange={(e) => this.setToDate(e)}
                                                            className="form-control"
                                                            popperProps={{
                                                                strategy: "fixed",
                                                                modifiers: [
                                                                    {
                                                                        name: "preventOverflow",
                                                                        options: {
                                                                            altAxis: true,
                                                                            altBoundary: true,
                                                                        }
                                                                    }
                                                                ]
                                                            }}
                                                            popperClassName="date-picker-popper"
                                                        />
                                                    </div>
                                                    <div style={{textAlign: 'right'}}>
                                                        <button 
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => this.setState({showDatePopover: false})}
                                                            style={{marginRight: '5px'}}
                                                        >
                                                            Apply
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-secondary"
                                                            onClick={() => this.setState({showDatePopover: false})}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ flex: '1' }}>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <label className="input-group-text" htmlFor="skuSelect">SKU</label>
                                                </div>
                                                <select value={this.state.skuType} className="custom-select" id="skuSelect"
                                                        onChange={(e) => this.selectSkuType(e)}>
                                                    <option value="">All</option>
                                                    <option value="Raw">Raw Materials</option>
                                                    <option value="Label">Labels</option>
                                                    <option value="ShippingM">Shipping Materials</option>
                                                    <option value="Containers">Containers</option>
                                                    <option value="Shipping">Shipping</option>
                                                    <option value="Coating">Coatings</option>
                                                    <option value="Freight">Transport & Misc</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div style={{ flex: '1' }}>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <label className="input-group-text" htmlFor="sourceSelect">Source</label>
                                                </div>
                                                <select className="custom-select" id="sourceSelect" value={this.state.vendor}
                                                        onChange={(e) => this.selectSourceName(e)}>
                                                    <option value="">All</option>
                                                    {this.state.sources.map((p, index) => (<option key={index}>{p.Source_Name}</option>))}
                                                </select>
                                            </div>
                                        </div>

                                        <div style={{ flex: '1' }}>
                                            <div className="input-group">
                                                <input onKeyPress={(e) => this.onKeyUp(e)} type="text" className="form-control"
                                                       onChange={(e) => this.onSearch(e)}
                                                       placeholder="Search by Peak#, SKU, supplier name..." aria-label="search"
                                                       value={this.state.search}
                                                       style={{padding: '20px'}} aria-describedby="basic-addon2"/>
                                                <div className="input-group-append">
                                                    <span onClick={(e) => this.onSearchClick(e)} 
                                                          className="input-group-text ti-search" id="basic-addon2"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Purchases List Section */}
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                                <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb' }}>
                                    <h5 style={{ fontWeight: '600', margin: 0 }}>Purchase Transactions ({this.state.totalItems} items)</h5>
                                </div>
                                
                                <div className="table-responsive table-container">
                                    <table className="table table-hover mb-0">
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 1)}>Peak#</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '200px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 1)}>SKU Name</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 2)}>Date</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Num</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '150px' }}>Memo</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '150px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 3)}>Supplier</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 4)}>Qty</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '60px' }}>U/M</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 5)}>Cost Price</span>
                                                </th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>
                                                    <span className='pointer' onClick={(e) => this.onOrderBy(e, 6)}>Amount</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ backgroundColor: '#f8f9fa', fontWeight: '600' }}>
                                                <td colSpan={6} style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>Total</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{this.numberWithCommasNotDollar(this.state.totalQty)}</td>
                                                <td colSpan={2} style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{this.numberWithCommas(this.state.totalAmount)}</td>
                                            </tr>

                                            {this.state.purchases.map((p, index) => (
                                                <tr key={index} style={{ cursor: 'pointer', borderTop: '1px solid #f3f4f6' }}>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                        <p className={(p.enrolled == true) ? 'green' : 'red'} onClick={(e) => this.handleComm(e, p.SkuNum)} style={{ margin: 0, cursor: 'pointer' }}>{p.SkuNum}</p>
                                                    </td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.SKU}>{p.SKU}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.Date}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.Num}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.Memo}>{p.Memo}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.Source_Name}>{p.Source_Name}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.Qty}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.U_M}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{this.appendDollarSign(p.Cost_Price)}</td>
                                                    <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{this.numberWithCommas(p.Amount)}</td>
                                                </tr>
                                            ))}
                                            
                                            {this.state.purchases.length === 0 && (
                                                <tr>
                                                    <td colSpan="10" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>No Purchase Records Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {this.state.isPrint === false && (
                                    <div className="pagination-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderTop: '1px solid #e5e7eb' }}>
                                        <div className="pagination-info" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div className="input-group" style={{ width: 'auto' }}>
                                                <select className="custom-select" id="perPageSelect" value={this.state.perPage}
                                                        onChange={(e) => this.onPerPageChange(e)}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <span style={{ color: '#6c757d', fontSize: '14px' }}>
                                                Showing {Math.min((this.state.pageNumber - 1) * this.state.perPage + 1, this.state.totalItems)} to {Math.min(this.state.pageNumber * this.state.perPage, this.state.totalItems)} of {this.state.totalItems} entries
                                            </span>
                                        </div>
                                        <PaginatedItems total={this.state.totalItems}
                                                        currentPage={this.state.pageNumber}
                                                        onPageChange={this.paginatePage}></PaginatedItems>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        );
    }
}

export default Purchases;